import { render, staticRenderFns } from "./PersonalityInspiringNewIdeasSection.vue?vue&type=template&id=326833a2"
import script from "./PersonalityInspiringNewIdeasSection.vue?vue&type=script&lang=ts"
export * from "./PersonalityInspiringNewIdeasSection.vue?vue&type=script&lang=ts"
import style0 from "./PersonalityInspiringNewIdeasSection.vue?vue&type=style&index=0&id=326833a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports